import { render, staticRenderFns } from "./GroupRole.vue?vue&type=template&id=10511ea6&scoped=true&"
import script from "./GroupRole.vue?vue&type=script&lang=js&"
export * from "./GroupRole.vue?vue&type=script&lang=js&"
import style0 from "./GroupRole.vue?vue&type=style&index=0&id=10511ea6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10511ea6",
  null
  
)

export default component.exports